import { TObjectShareResponse } from "../../../../services/api/instances/storageApi/types/service_types";
import { createDefaultDate } from "../../../../shared/utils/createDefaultDate";

export const aggregatePermissions = (
  permissions: TObjectShareResponse[],
  objectId: string,
) => {
  const currentPermissions = permissions.filter(
    (permission) => permission.object_id === Number(objectId),
  );

  if (currentPermissions.length === 0 || permissions.length === 0) {
    return [
      {
        username: [],
        valid_till: createDefaultDate({ months: 1 }).toISOString(),
        write: false,
        active: true,
        id: Date.now() + Math.floor(Math.random() * 1000),
        object_id: Number(objectId),
        permission_pairs: [],
      },
    ];
  }

  if (currentPermissions.length === 1) {
    const permission = {
      ...currentPermissions[0],
      username: (currentPermissions[0].username as string).replace(
        "@education_tools",
        "",
      ),
      permission_pairs: [
        {
          id: currentPermissions[0].id,
          username: (currentPermissions[0].username as string).replace(
            "@education_tools",
            "",
          ),
          origin: "persisted" as const,
          isTemporary: false,
        },
      ],
    };
    return [permission];
  }

  const aggregated = Object.values(
    currentPermissions.reduce(
      (acc, permission) => {
        const key = `${permission.write}-${permission.valid_till}`;
        const cleanName = (permission.username as string).replace(
          "@education_tools",
          "",
        );

        if (acc[key]) {
          acc[key] = {
            ...acc[key],
            id: Date.now() + Math.floor(Math.random() * 1000),
            permission_pairs: [
              ...(acc[key].permission_pairs ?? [
                {
                  id: acc[key].id as number,
                  username: (acc[key].username as string).replace(
                    "@education_tools",
                    "",
                  ),
                  origin: "persisted" as const,
                  isTemporary: false,
                },
              ]),
              {
                id: permission.id,
                username: cleanName as string,
                origin: "persisted" as const,
                isTemporary: false,
              },
            ],
            username: [
              ...(Array.isArray(acc[key].username)
                ? acc[key].username
                : [acc[key].username.replace("@education_tools", "")]),
              cleanName,
            ] as string[],
          };
        } else {
          acc[key] = {
            ...permission,
            username: [cleanName],
            permission_pairs: [
              {
                id: permission.id as number,
                username: cleanName,
                origin: "persisted" as const,
                isTemporary: false,
              },
            ],
          };
        }

        return acc;
      },
      {} as Record<string, TObjectShareResponse>,
    ),
  );
  return aggregated;
};
